import React from 'react'
import { Route, IndexRoute } from 'react-router'

import Container from './containers/Container'
import connectListContainer from '../shared/connectors/ListContainer'
import DetailsContainer from './containers/DetailsContainer'

import getPath from '../../shared/utils/getPath'

const programRoutes = (
  <Route
    component={Container}
    key="program-routes"
    path={getPath('frontend', 'program')}
  >
    <IndexRoute component={connectListContainer('program')} />
    <Route
      path={getPath('frontend', 'program', ':id')}
      component={DetailsContainer}
    />
  </Route>
)

export default programRoutes



// WEBPACK FOOTER //
// ./src/frontend/program/routes.js